import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretLeft16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCaretLeft16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.215 13.868a.5.5 0 0 1-.707 0L4.992 8.352 4.64 8l.353-.354 5.514-5.513a.5.5 0 0 1 .707.707L6.054 8l5.162 5.162a.5.5 0 0 1 0 .707"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretLeft16);
